import React from "react";
import HeadLines from "../CommonComponents/HeadLines";
import { isMobile } from "../helperFunc";
import { location } from "../icon_assets";
import style from "./style.module.css";

const MandiCard = ({ data, index, isRightView = false }) => {
  return (
    <>
      <div
        className={`${
          isMobile ? "padding12" : " padding16 backgroundWhite lightBorder"
        }  d-flex justify-content-space-between ${
          index > 0 ? style["lightBorderTop"] : ""
        }`}
      >
        <div className={` ${isMobile ? "" : !isRightView && "margin-left16"}`}>
          <HeadLines
            text={data.commodity_lang}
            className={`font-weight400  ${
              isMobile
                ? "line-height16 letterSpacing001  font-size14"
                : "line-height19 letterSpacing05  font-size16"
            } colorDark1 padding-bottom8`}
          />
          <div className="d-flex align-items-center">
            <img src={location} alt="" />
            <HeadLines
              text={data.location}
              className={`font-weight400 colorDark7 padding-left4  ${
                isMobile
                  ? "line-height14 letterSpacing025 font-size12"
                  : "line-height16 letterSpacing05  font-size14"
              }`}
            />
          </div>
        </div>
        <div
          className={`${style["text-align-right"]} ${
            isMobile ? "" : !isRightView && "margin-right16"
          }`}
        >
          <HeadLines
            text={`₹${parseFloat(data.price).toLocaleString("en-IN")}/MT`}
            className={`font-weight500  ${
              isMobile
                ? "line-height16 letterSpacing001  font-size14"
                : "line-height19 letterSpacing05  font-size16"
            }  padding-bottom8`}
          />
          {data.profit_loss == 0 ? (
            ""
          ) : (
            <>
              <HeadLines
                text={`${data.profit_loss > 0 ? "+ ₹" : "- ₹"}${Math.abs(
                  Number(data?.profit_loss?.toFixed(2))
                )}`}
                className={`${
                  data.profit_loss > 0
                    ? style["successColor"]
                    : style["failureColor"]
                } display-inline-block padding-right4 font-weight500 ${
                  isMobile
                    ? "line-height14 letterSpacing025 font-size12"
                    : "line-height16 letterSpacing05  font-size14"
                }`}
              />
            </>
          )}
          <HeadLines
            text={
              data.profit_loss == 0
                ? "no change since last week"
                : " since last week"
            }
            className={`display-inline-block colorDark7 font-weight400 ${
              isMobile
                ? "line-height14 letterSpacing025 font-size12"
                : "line-height16 letterSpacing05  font-size14"
            }`}
          />
        </div>
      </div>
    </>
  );
};
export default MandiCard;
